import Modal from 'components/core-ui/Modal/Modal'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import sl from '../../partners.modules.scss'
import { Box, Checkbox, FormControlLabel, FormGroup, Grid } from '@mui/material'
import { Input } from 'components/core-ui/Input'
import { Button, DatePicker, RadioButtonGroup } from '@fullscreendigital/carrefour-dex-fe'
import dayjs from 'dayjs'

const PartnerConfirmationModal = props => {
  const { isModalOpen, cancelModal, partnerFormik, assignmentFormik, isSubmitting } = props

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={cancelModal}
      modalTitle="Please validate new partner data"
      modalWidth="50%"
    >
      <Box className={sl.partnerValidationInfoContainer}>
        Red values can't be changed after validation
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={6} className={sl.partnerValidationInfoItem}>
          <Input
            type="text"
            variant="outlined"
            name="firstName"
            label="First Name"
            width="100%"
            value={partnerFormik.values.firstName}
            disabled
            required
            style={{ color: 'red' }}
          />
        </Grid>
        <Grid item xs={6} className={sl.partnerValidationInfoItem}>
          <Input
            type="text"
            variant="outlined"
            name="lastName"
            label="Last Name"
            width="100%"
            value={partnerFormik.values.lastName}
            disabled
            required
          />
        </Grid>
        <Grid item xs={6} className={sl.partnerValidationInfoItem}>
          <Input
            type="text"
            variant="outlined"
            name="externalPartnerType"
            label="Partner type"
            width="100%"
            value={partnerFormik.values.externalPartnerType?.label}
            disabled
            required
          />
        </Grid>
        <Grid item xs={6} style={{ position: 'relative' }} className={sl.partnerValidationInfoItem}>
          <Box style={{ marginTop: '20px', position: 'absolute', left: '18px' }}>
            <RadioButtonGroup
              label="Extension period (months)"
              dotStyle
              name="extensionPeriod"
              value={partnerFormik.values.extensionPeriod}
              row
              disabled
              options={[
                {
                  label: '1',
                  value: '1'
                },
                {
                  label: '3',
                  value: '3'
                },
                {
                  label: '6',
                  value: '6'
                },
                {
                  label: '12',
                  value: '12'
                }
              ]}
            />
          </Box>
        </Grid>
        <Grid item xs={6} className={sl.partnerValidationInfoItem}>
          <DatePicker
            variant="outlined"
            label="Start Date"
            value={dayjs(assignmentFormik.values.startDate)}
            onChange={value => assignmentFormik.setFieldValue('startDate', value)}
            required
            disabled
            style={{ width: '100%' }}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            variant="outlined"
            label="End Date"
            value={dayjs(assignmentFormik.values.endDate)}
            onChange={value => assignmentFormik.setFieldValue('endDate', value)}
            required
            disabled
            style={{ width: '100%' }}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <FormGroup row style={{ padding: 0 }}>
            <FormControlLabel
              control={
                <Checkbox checked={assignmentFormik.values.adAccount} name="adAccount" disabled />
              }
              label="AD Account"
              className={sl.digitalAccountCheckboxLabel}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={assignmentFormik.values.ldapAccount}
                  name="ldapAccount"
                  onChange={assignmentFormik.handleChange}
                  disabled
                />
              }
              label="LDAP Account"
              className={sl.digitalAccountCheckboxLabel}
              disabled
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={assignmentFormik.values.googleAccount}
                  name="googleAccount"
                  disabled
                />
              }
              label="Google Account"
              className={sl.digitalAccountCheckboxLabel}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            style={{
              fontSize: '10px',
              fontFamily: 'Ubuntu',
              lineHeight: '42px',
              textAlign: 'right'
            }}
          >
            (one digital account mandatory)
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Input
            type="text"
            variant="outlined"
            name="manager"
            label="Manager"
            width="100%"
            value={assignmentFormik.values.manager?.label}
            disabled
            required
          />
        </Grid>
        <Grid item xs={12} className={sl.partnerValidationInfoItem}>
          <Input
            type="text"
            variant="outlined"
            name="legalEntity"
            label="Legal entity name"
            width="100%"
            value={
              assignmentFormik.values.existingLegalEntityName ||
              assignmentFormik.values.legalEntityName
            }
            disabled
            required
          />
        </Grid>
        <Grid item xs={12} className={s.modalButtons}>
          <Button variant="outlined" label="Back" onClick={cancelModal} />
          <Button
            variant="contained"
            label="Save"
            onClick={() => assignmentFormik.handleSubmit()}
            disabled={isSubmitting}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default PartnerConfirmationModal
